//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#select_promotion

class SelectPromotionEventListener {
    // Language: javascript
    // Path: SelectPromotionEventListener.js
    // Compare this snippet from EventListener.js:
    get CheckoutProducts() {
        return ".gtm-checkout-products";
    }
    get cartItems() {
        return ".gtm-view-cart";
    }
    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }
    callback(couponCode, couponName) {
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var items;
        var pushItems = [];

        var cartItems = document.querySelectorAll(
            SelectPromotionEventListener.prototype.cartItems
        );
        var checkoutProducts = document.querySelectorAll(
            SelectPromotionEventListener.prototype.CheckoutProducts
        );
        var quantites = document.querySelectorAll(
            SelectPromotionEventListener.prototype.cartItems +
                " .number-unit input"
        );
        var coupon = {
            couponCode: couponCode,
            couponName: couponName,
        };

        if (!!cartItems && cartItems.length > 0) items = cartItems;
        if (!!checkoutProducts && checkoutProducts.length > 0)
            items = checkoutProducts;

        if (!!items) {
            for (var i = 0; i < items.length; i++) {
                var cartItem = items[i];
                var analyticsData = cartItem.dataset.analytics
                    ? JSON.parse(cartItem.dataset.analytics)
                    : null;

                if (analyticsData && cartItem.dataset) {
                    var analticsDataProducts = analyticsData.products
                        ? analyticsData.products[0]
                        : null;
                    var quantity = !!cartItem.dataset.quantity
                        ? cartItem.dataset.quantity
                        : parseFloat(quantites[i].value);

                    var price = Number(
                        analticsDataProducts.price.replace(",", ".")
                    ).toFixed(2);
                    var pricewithdiscount = Number(
                        analticsDataProducts.pricewithdiscount.replace(",", ".")
                    ).toFixed(2);

                    var item = {
                        item_id: analticsDataProducts.code,
                        item_name: analticsDataProducts.name,
                        coupon: coupon.couponName,
                        item_brand: analticsDataProducts.brand,
                        item_category: analticsDataProducts.category,
                        currency: analticsDataProducts.currency,
                        price: pricewithdiscount,
                        quantity: quantity,
                    };

                    if (analticsDataProducts.categories) {
                        var splitCategories =
                            analticsDataProducts.categories.split(";");
                        for (var j = 0; j < splitCategories.length; j++) {
                            if (j == 0) {
                                item["item_category"] = splitCategories[j];
                            } else {
                                item["item_category" + j] = splitCategories[j];
                            }
                        }
                    }

                    if (cartItem.dataset.variant) {
                        var variant = JSON.parse(cartItem.dataset.variant);
                        if (variant) {
                            item["item_variant"] =
                                Object.values(variant).join(",");
                        }
                    }

                    if (price != pricewithdiscount) {
                        item["price"] = price;
                        item["discount"] = (price - pricewithdiscount).toFixed(
                            2
                        );
                    }

                    pushItems.push(item);
                }
            }

            if (pushItems.length > 0) {
                SendData(dataLayer);
            }

            function SendData(dataLayer) {
                dataLayer
                    .push({
                        event: "select_promotion",
                        ecommerce: {
                            items: pushItems,
                        },
                    })
                    .then(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activatePurchaseCheckout();
                        console.log("GTM pushed select_promotion event");
                    })
                    .catch((error) => {
                        console.warn("GTM error select_promotion event", error);
                    });

                if (typeof gtag !== "undefined" && !!gtag) {
                    gtag("event", "select_promotion", {
                        event_category: "Enhanced Ecommerce",
                        event_label: "select promotion",
                        promotion_id: coupon.couponCode,
                        promotion_name: coupon.couponName,
                        items: pushItems,
                    });
                }
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            SelectPromotionEventListener.prototype.callback
        );
    }
    remove() {
        this.element.removeEventListener(
            this.eventName,
            SelectPromotionEventListener.prototype.callback
        );
    }
}
